// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

// 验证是否为blob格式
export function blobValidate(data) {
  return data.type !== 'application/json'
}

// 去除html字符串中的style
export function removeHtmlStyle(htmlStr) {

  let relStyle = /style\s*?=\s*?([‘"])[\s\S]*?\1/g;// 去除样式
  // let relTag = /<.+?>/g;//去除标签
  let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;//去除类名
  // let relImg = /<\/?(img)[^>]*>/g;//去除img
  let newStr = '';
  if(htmlStr){
    // newStr = htmlStr.replace(relImg,'');
    newStr = htmlStr.replace(relStyle,'');
    // newStr = newStr.replace(relTag,'');
    // newStr = newStr.replace(relClass,'');
  }
  return newStr;
}

// 去除html字符串中所有样式，标签，类名
export function handleHtmlString(htmlStr) {

  // let relStyle = /style\s*?=\s*?([‘"])[\s\S]*?\1/g;// 去除样式
  let relTag = /<.+?>/g;//去除标签
  // let relClass = /class\s*?=\s*?([‘"])[\s\s]*?\1/g;//去除类名
  // let relImg = /<\/?(img)[^>]*>/g;//去除img
  let newStr = '';
  if(htmlStr){
    // newStr = htmlStr.replace(relImg,'');
    // newStr = newStr.replace(relStyle,'');
    newStr = htmlStr.replace(relTag,'');
    // newStr = newStr.replace(relClass,'');
  }
  return newStr;
}
  
// 处理新闻类数组
export function handleNewsData(data){
  if(data && Array.isArray(data)){
    for (const index in data) {
      
      let item = data[index];
      
      item = handleNewsItem(item);

    }
  
    return data;
  }else if(typeof(data) == 'object'){

    data = handleNewsItem(data);
  
    return data;
  }else{

    return data;
  }

}


function handleNewsItem(item) {

  let showTime = '';
  if(item.activeTime){
    item.activeTime = item.activeTime.replace(/-/g,'/');
    showTime = item.activeTime.split(' ')[0];

    const activeDate = new Date(item.activeTime);
    item.activeDate = activeDate;
    
    item.year = activeDate.getFullYear() +'年'+(activeDate.getMonth()+1)+'月';
    item.day = activeDate.getDate();
    if(item.day < 10){
      item.day = '0'+item.day;
    }else{
      item.day = JSON.stringify(item.day);
    }
    item.detailTime = item.year + item.day+'日';

  }
  item.showTime = showTime;
  return item;
}

// 获取人员数组中选中的人员id数组，返回人员姓名数组
export function getSelectedPeopleNames(datas, userIds) {
  if (userIds === undefined) {
    return [];
  }
  var actions = [];
  for (const index in userIds) {
    
    let userId = userIds[index];
    Object.keys(datas).some((key) => {
      if (datas[key].userId == ( userId)) {
        actions.push(datas[key].name);
        return true;
      }
    })
  }
  
  return actions;
}
  
//对字符串进行转码
export function compileStr(code){
  var c=String.fromCharCode(code.charCodeAt(0)+code.length);
  for(var i=1;i<code.length;i++){
    c+=String.fromCharCode(code.charCodeAt(i)+code.charCodeAt(i-1));
  }
  return escape(c);
}

//字符串进行解码
export function uncompileStr(code){
  code = unescape(code);
  var c=String.fromCharCode(code.charCodeAt(0)-code.length);
  for(var i=1;i<code.length;i++){
    c+=String.fromCharCode(code.charCodeAt(i)-c.charCodeAt(i-1));
  }
  return c;
}

//判断是否json字符串，保存本地的数据，避免被修改解码错误
export function isJsonString(str){
  try {
    JSON.parse(str)
    return true;
  } catch (error) {
    return false;
  }
}

export function hightLightString(keyword,suggtion){

  if(keyword && suggtion){
    if(keyword == '')return suggtion;
    const reg = new RegExp (keyword,'ig')
    const newStr = suggtion.replace(reg,function (p) {
      return '<span style="color:#C80018;font-weight:bold;text-decoration: underline;">' + p + '</span>'    
    })
    return newStr;
  }

  return suggtion;
}